import InvestmentPreferenceContainer from "./InvestmentPreferenceContainer";
import InvestmentPreferenceStore from "./InvestmentPreferenceStore";

export default InvestmentPreferenceStore(InvestmentPreferenceContainer);
